import axios from 'api/axios';
import { CancelToken } from 'axios';
import {
  AnimationSkip,
  FilterType,
  PaginationType,
  SortType,
  UserRoleEnum,
  UserTypeCommonFields,
  WorkActivity,
} from 'utils/types';

const path = 'user';

type ParamsType = {
  sort?: SortType;
  pagination?: PaginationType;
  filter: FilterType;
};

export const getList = (
  params: ParamsType,
  cancelToken?: CancelToken,
): Promise<{ data: UserTypeCommonFields[]; count: number }> =>
  axios.get(path, {
    params: {
      ...params.sort,
      ...params.pagination,
      filter: {
        role: params.filter.role,
      },
    },
    cancelToken,
  });

export const changeUserRole = (
  id: number,
  newRole: UserRoleEnum,
): Promise<any> => axios.put(`${path}/change-role/${id}`, {
  newRole,
});

export const changeUserPassword = (
  data: { currentPassword: string; newPassword: string },
): Promise<any> => axios.patch(`${path}/change-password`, data);

export const forgotPassword = (
  data: { email: string },
): Promise<any> => axios.post(`${path}/forgot-password/`, data);

export const deleteUser = (id: number): Promise<any> => axios.delete(`${path}/${id}`);

export const skipAnimation = (id: number, data: AnimationSkip) => axios.patch(`${path}/skip-animation/${id}`, data);

export const workActivity = (data: {
  description?: string;
  teamId?: number | null;
  vacancies?: number[];
}): Promise<WorkActivity> => axios.put(`${path}/work-activity`, data);

export const stopWorkActivity = () => axios.patch(`${path}/stop-work-activity`);
export const getWorkActivities = (data:
  { userIds?: number[], teamId?: number, from?: Date, to?: Date},
): Promise<WorkActivity[]> => axios.get(
  `${path}/work-activities`,
  {
    params: {
      userIds: data.userIds?.join(','),
      teamId: data.teamId,
      from: data.from?.toISOString(),
      to: data.to?.toISOString(),
    },
  },
);

const userApi = {
  getList,
  changeUserRole,
  deleteUser,
  skipAnimation,
  changeUserPassword,
  forgotPassword,
  workActivity,
  stopWorkActivity,
  getWorkActivities,
};

export default userApi;
